import React from 'react'
import { Link } from 'react-router-dom'

function Clickgo() {
    return (
        <div className='font-thin'>
              <div className="w-full px-6 md:px-16  mx-auto  max-w-7xl">
    
    {/* ✅ Breadcrumb Navigation */}
    <div className="flex justify-start text-sm md:text-base">
           <Link to="/" className="block py-1 pl-4 hover:underline  mt-6">Home -</Link>
           <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline mt-6">Typologies -</Link>
           <Link to="/intelligent" className="block py-1 pl-4 hover:underline mt-6">Intelligent -</Link>
           <span className="block py-1 pl-4 mt-6">CLICK & COLLECT</span>
    
         </div>
         {/* ✅ Product Image on Top */}
         <div className="flex justify-center mb-6">
           <img src="/images/click&.png" alt="Vista" className="max-w-full h-auto object-contain" />
         </div>
    
         {/* ✅ Product Title & Description */}
         <div className="text-center mb-6">
           <h1 className="text-3xl md:text-4xl uppercase mb-8">CLICK & COLLECT</h1>
           <p className="text-xl lg:text-2xl font-thin max-w-sm mx-auto text-gray-500">Controlled temperature lockers for e-commerce deliveries.</p>
           <p className="text-xl lg:text-2xl font-thin opacity-80 max-w-7xl mx-auto text-gray-500 mt-10">Grocery e-commerce 24/7 solution to reduce parcel delivery costs. Designed as a plug-in and modular system that allows multiple options and configurations to adjust to your business easily. It enables an Easy, Convenient and Safe for your customers to retrieve their online orders in the best storage conditions.</p>
         </div>
    
         {/* ✅ Models & Model Values */}
    <h2 className="text-3xl font-thin opacity-80 text-gray-500 mb-8 text-center ">Temperatures</h2>
    
    <div className="grid grid-cols-1 gap-4 text-center mb-6">
      
       <p className="text-xl lg:text-2xl opacity-90">FROZEN FOODS <span className='text-fuchsia-950'> -18°… -15°C</span> (3L1)</p>
       <p className="text-xl lg:text-2xl opacity-90">CHILLED FOODS <span className=' text-blue-400'>-1°… +5°C</span><span className=' text-gray-400'> (3M1)</span> </p>
       <p className="text-xl lg:text-2xl opacity-90">HEATED FOODS <span className='text-red-500'>+65°… +70°C</span> </p>
    </div>
    
    <div className='text-center'>
        <p className='text-3xl'>Formats</p>
        <p className='text-xl lg:text-2xl '><span className='text-black font-semibold'>S</span> 47,7/51,7* |</p>
        <p className='text-xl lg:text-2xl '><span className='text-black font-semibold'>M</span> 82,1/90,1* |</p>
        <p className='text-xl lg:text-2xl '><span className='text-black font-semibold'>L</span> 117,6/129,6* |</p>
        <p className='text-xl lg:text-2xl '><span className='text-black font-semibold'>XL</span>186,4/204,4* |</p>
        <p className='text-xl lg:text-2xl mt-6'>* Capacity in litres for pass-through models</p>

    </div>
         {/* ✅ Refrigeration */}
         <div>
           <h2 className="text-3xl font-thin text-center mt-10 text-gray-500 ">Refrigeration</h2>
           <p className="text-xl lg:text-2xl text-lime-500 text-center mt-3"> R290</p>
         </div>
    
    
    
         {/* ✅ Case Images & Features */}
         <div className="flex flex-col gap-8 md:pt-32">
            {/* case 1 */}
             <div 
               className="flex flex-col  pb-16 mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4"> 
        <p className="text-2xl text-orange-600">Adjustable to your business!</p>
        <ul className="list-[square] list-outside text-gray-500">
    <li className="text-xl font-thin opacity-90 mt-6"><span className='text-orange-600'>Reduce delivery time and costs,</span> including transport and labour.</li>
    <li className="text-xl font-thin opacity-90 mt-6"><span className='text-orange-600'>24/7 accessibility,</span> adapts to shopper's schedules and convenience, no lines, no waiting.</li>
    <li className="text-xl font-thin opacity-90 mt-6"><span  className='text-orange-600'>Versatile</span> and <span className='text-orange-600'> fully customizable,</span> retailers can choose their own combination and lockers' sizes that best suit their businesses.</li>
    <li className="text-xl font-thin opacity-90 mt-6"><span className='text-orange-600'> 4 locker sizes</span> - S, M, L, XL - to cope with small and big parcels, maximizing the existing space.</li>
    <li className="text-xl font-thin opacity-90 mt-6"><span className='text-orange-600'> Pass-through model</span> for rear loading which facilitates operations without disturbing order collection.</li>
    <li className="text-xl font-thin opacity-90 mt-6"><span className='text-orange-600'> Inclusive design</span> prepared for wheelchair users.</li>
    <li className="text-xl font-thin opacity-90 mt-6"><span className='text-orange-600'> Branding</span> opportunities.</li>
</ul>

    </div>
                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/clicknew.png" className="max-w-full h-auto object-contain" />
               </div>
             </div>
    
            {/* case 2 */}
             <div 
               className="flex flex-col  pb-16 mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/clickcase.jpg" className="max-w-full h-auto object-contain" />
               </div>
    
               <div className="w-full md:w-1/2 px-4"> 
        <p className="text-2xl text-orange-600">Online orders always in the best storage conditions!</p>
        <ul className="list-[square] list-outside text-gray-500">
    <li className="text-xl font-thin opacity-90 mt-6">Models for <span  className='text-orange-600'> chilled, frozen, dry,</span> and<span className='text-orange-600'> heated</span>  goods.</li>
    <li className="text-xl font-thin opacity-90 mt-6">Isolated refrigeration/heating system <span className='text-orange-600'> with no risk of food contamination</span> between lockers.</li>
</ul>

    </div>
             </div>
    
    {/* case 3 */}
    <div 
               className="flex flex-col  pb-16 mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4"> 
        <p className="text-2xl text-orange-600">Intuitive and easy to use!</p>
        <ul className="list-[square] list-outside text-gray-500">
            <li className="text-xl font-thin opacity-90 mt-6">Choose from different types of <span className='text-orange-600'>  unlocking technologies</span> like QR/bar codes scanner, NFC technology, touch screen...</li>
        </ul>
    </div>
                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/clickcase1.png" className="max-w-full h-auto object-contain" />
               </div>
             </div>
    
            {/* case 4 */}
            <div 
               className="flex flex-col  pb-16 mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
              
        {/* ✅ Image Wrapper */}
        <div className="w-full md:w-1/2">
        <img src="/images/clickcase2.gif" className="max-w-full h-auto object-contain" />
      </div>
    
      <div className="w-full md:w-1/2 px-4"> 
        <p className="text-2xl text-orange-600">Monitoring and App integration</p>
        <ul className="list-[square] list-outside text-gray-500">
            <li className="text-xl font-thin opacity-90 mt-6">Remote monitoring and parcel collection control in real time.</li>
            <li className="text-xl font-thin opacity-90 mt-6">Retailer’s app integration.</li>
        </ul>
    </div>
             </div>
    
            
         </div>
    
     </div>
    
        </div>
      )
    }

export default Clickgo